module.exports = __webpack_public_path__ + "static/img/hero-1.e0661ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-1.jpg
// module id = qzCX
// module chunks = 0